import React from "react";

function SnapCart() {
    return (
        <div id="project" style={{ paddingBottom: 200 }}>
            <h1 id="projectHeader">SnapCart</h1>
            <p id="projectSub"><i>TypeScript, Next.js, Tailwind, Postgres (Neon + Drizzle), Claude vision, SerpAPI, Vercel</i></p>
            <p>
                SnapCart lets you snap a photo of any object and turn it into a shoppable list — no typing a search query required. Snap a photo of something you saw and liked (in a store, someone's home, a magazine), Claude's vision model identifies it, and SnapCart finds real, purchasable similar products for it.
                <br></br><br></br>
                I built SnapCart as a growth/monetization-shaped project: the core loop — capture → detect → save → discover → click-through — is a funnel, and every step is instrumented so it mirrors the kind of product I'd actually ship on a growth team.
            </p>
            <div>
                <a target="_blank" rel="noopener noreferrer" href="https://github.com/ambermichellelynn/snapcart">Github</a>
                &nbsp;&nbsp;
                <a target="_blank" rel="noopener noreferrer" href="https://snapcart-livid.vercel.app/">Demo</a>
            </div>
            <br></br><br></br>
            <video controls style={{ width: "82.5%", borderRadius: 10, border: "1px #dcdee8 solid" }}>
                <source src="/videos/snapcart-demo.mov" type="video/mp4" />
                Your browser doesn't support embedded video.
            </video>
            <br></br><br></br>
            <h3>How it works</h3>
            <p>
                Users capture or upload a photo on the home page. The image is sent to Claude (vision), which returns a structured label and category for the main shoppable object. That detection is saved to a session-scoped list — no login required. From the list page, expanding an item calls Google Shopping via SerpAPI using the detected label as the query, and renders real product cards with price, thumbnail, and an outbound link.
            </p>
            <br></br>
            <h3>Growth instrumentation</h3>
            <table>
                <tr>
                    <td style={{ paddingRight: 100 }}><li>Detection success/failure tracking</li></td>
                    <td><li>Save-to-list activation events</li></td>
                </tr>
                <tr>
                    <td style={{ paddingRight: 100 }}><li>"View similar" intent tracking</li></td>
                    <td><li>Click-through events on similar items, logged with title/link/price</li></td>
                </tr>
            </table>
            <br></br><br></br>
            <p>
                That event data is the foundation for things a growth engineer would actually want to ship next: A/B testing the similar-items ranking, affiliate-tagging outbound product links for revenue attribution, analyzing the detect → save activation funnel, and testing retention nudges keyed off saved items with no follow-up engagement.
            </p>
        </div>
    )
}

export default SnapCart;
